<template>
  <div>
    <a-select
			v-model="model.reference_no"
			showSearch
			:filterOption="(input, option) => option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0" 
			class="ts-w-full"
			:options="quotationList"
			@change="addItem"
		></a-select>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'referenceNumber',
  props: ['value'],
  data() {
    return {
      model: {},
    }
  },
  created() {
    this.model = this.value
  },
	computed: {
		...mapState('wholesale/saleContract', ['quotations']),
		quotationList() {
			return this.quotations.map(el => ({
				value: el.quotation_no,
				label: el.quotation_no,
			}))
		}
	},
	methods: {
		addItem(value, options) {
			var quotation = this.quotations.find(q => q.quotation_no == value)

			this.model.project_name = quotation.project_name
      this.model.customer_id = quotation.customer_id
      this.model.grand_total = quotation.grand_total
      this.model.vat_rate = quotation.vat_rate
      this.model.vat_amount = quotation.vat_amount
      this.model.total_exclude_vat = quotation.total_exclude_vat
      this.model.item_list = quotation.details.filter(q => q.quantity - q.quantity_received > 0).map(el => ({
				  product_id: el.product_id,
					uom_id: el.uom_id,
					quantity: el.quantity - el.quantity_received,
					unit_price: el.unit_price,
					remarks: el.remarks,
					amount: _.round(el.unit_price * (el.quantity - el.quantity_received), 2),
			}))
		}
	},
}
</script>